import React, { useState } from 'react';

import { IChangeEvent } from '@rjsf/core';
import Form from '@rjsf/mui';
import { RJSFSchema } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';

import { Alert, Button } from '@mui/material';

import { queueBreakdownNonredemptions } from '~/services/ReportingService';

import ErrorDisplay from '../ErrorDisplay';

const formSchema: RJSFSchema = {
  description: 'Please enter an offer and date to export all bookings between the selected date range',
  type: 'object',
  properties: {
    startAt: {
      title: 'Select Start Date',
      type: 'string',
      format: 'date',
    },
    endAt: {
      title: 'Select End Date',
      type: 'string',
      format: 'date',
    },
    idOffer: {
      title: 'Offer ID',
      type: 'string',
    },
    leOfferId: {
      title: 'LE Offer ID',
      type: 'string',
    },
  },
};

const uiSchema = {
  startAt: {
    'ui:widget': 'date',
  },
  endAt: {
    'ui:widget': 'date',
  },
  idOffer: {
    'ui:widget': 'text',
  },
  leOfferId: {
    'ui:widget': 'text',
  },
};

export default function ExportBreakdownNonredemptionsForm() {
  const [successMessage, setSuccessMessage] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = (event: IChangeEvent) => {
    queueBreakdownNonredemptions({
      startAt: event.formData.startAt,
      endAt: event.formData.endAt,
      idOffer: event.formData.idOffer,
      leOfferId: event.formData.leOfferId,
    })
      .then(() => {
        setSuccessMessage(true);
      })
      .catch(function (err) {
        setError(err.message);
      });
  };

  return (
    <div>
      <Form schema={formSchema} uiSchema={uiSchema} onSubmit={handleSubmit} validator={validator} showErrorList={false}>
        <Button type="submit" variant="contained">
          Email Breakdown Nonredemption Bookings Report
        </Button>

        {error && <ErrorDisplay message={error} />}

        {successMessage && (
          <Alert severity="success">
            <p>Your report is queued for delivery and will be emailed shortly.</p>
          </Alert>
        )}
      </Form>
    </div>
  );
}
